import React from "react";
import "./Specifications.css";

export default function Index({ data }) {
  return (
    <section className="specification">
      <div className="container">
        <div className="row flex-row-reverse">
          <div className="col-lg-6">
            <div className="text-wrapper">
              <div className="table-cell">
                <h3 className="accent">{data.specifications.title}</h3>
                {data.specifications.detail.length > 0
                  ? data.specifications.detail.map((item) => (
                      <div className="row flex-table">
                        <div className="col table-key">
                          <span className="after-border">{item.key}</span>
                        </div>
                        <div className="col table-value">
                          <span>{item.value}</span>
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              src={data.specifications.img}
              className="flashbot-img"
              alt="goopter flashbot"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
